/**
 * Computes the player-card rectangle in canvas-buffer pixels for the
 * tap-toggle overlay. The card now lives over a dimmed backdrop instead of
 * sharing the top row with the table felt, so it can take up significantly
 * more of the viewport — sized to a credit-card-ish ~1.5 tall-to-wide ratio
 * and centered horizontally with a comfortable top margin.
 *
 * Scales down on landscape / desktop so the card never blows past 70% of the
 * viewport height.
 */
export function computePlayerCardRect(W: number, H: number): { x: number; y: number; w: number; h: number } {
  const targetW = Math.round(W * 0.55);
  const targetH = Math.round(targetW * 1.5);
  const maxH = Math.round(H * 0.7);
  const cardH = Math.min(targetH, maxH);
  const cardW = Math.round(cardH / 1.5);
  const cardX = Math.round((W - cardW) / 2);
  const cardY = Math.round(H * 0.12);
  return { x: cardX, y: cardY, w: cardW, h: cardH };
}
